import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '../../App';
import { toast } from 'react-toastify';

function AdminLayout({ children, session }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    try {
      // Clear admin token
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');

      // Also sign out from Supabase if logged in
      if (supabase) {
        await supabase.auth.signOut();
      }

      toast.success('Logged out successfully!');
      navigate('/');
    } catch (error) {
      toast.error('Error logging out');
    }
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="dashboard-container">
      {/* Header */}
      <div className="dashboard-header">
        <div className="header-content">
          <Link to="/" className="logo" style={{ textDecoration: 'none' }}>
            <span className="zero">ZERO</span>
            <span className="ping">PING</span>
          </Link>

          <div className="nav-menu">
            <Link
              to="/admin"
              className={`nav-link ${isActive('/admin') ? 'active' : ''}`}
            >
              ⚡ Dashboard
            </Link>
            <Link
              to="/admin/withdrawals"
              className={`nav-link ${isActive('/admin/withdrawals') ? 'active' : ''}`}
            >
              💸 Withdrawals
            </Link>
            <button className="btn btn-danger" onClick={handleLogout} style={{ padding: '8px 16px' }}>
              Logout
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="dashboard-content">
        {children}
      </div>
    </div>
  );
}

export default AdminLayout;
